import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { Button } from '../ui/button';
import { Trash2 } from 'lucide-react';

export interface DeleteCellRendererProps extends ICellRendererParams {
	onDelete?: (data: any) => void;
	disabled?: boolean;
	className?: string;
}

export const DeleteCellRenderer: React.FC<DeleteCellRendererProps> = ({
	data,
	onDelete,
	disabled = false,
	className = ''
}) => {
	const handleDelete = (e: React.MouseEvent) => {
		e.stopPropagation();
		if (!disabled && onDelete) {
			onDelete(data);
		}
	};

	return (
		<div className={`flex items-center justify-center h-full ${className}`}>
			<Button
				size="sm"
				variant="ghost"
				onClick={handleDelete}
				disabled={disabled}
				className="w-8 h-8 p-0 transition-all duration-200 border rounded-lg border-border/50 text-foreground hover:text-foreground hover:bg-accent hover:border-border"
				title="Delete"
			>
				<Trash2 className="w-4 h-4" />
			</Button>
		</div>
	);
};